module.exports = __webpack_public_path__ + "img/group25@2x-th.c81c402e.png";